import {
  PURCHASE_URL
} from 'shared/utils/Constants';

import {
  post
} from 'shared/services/ApiService';

class PurchaseService {
  async purchase(params) {
    return post(PURCHASE_URL, params);
  }
}

export default new PurchaseService();
